import React from "react";
import FormLabel from "./styled/FormLabel";
import DocumentCard from "./styled/DocumentCard";
import CVDocumentUploader from "./styled/CVDocumentUploader";

const CVForm = ({ cvDocument, handleCVChange, loadingCV }) => {
  return (
    <>
      <FormLabel>Adjuntar Curriculum Vitae</FormLabel>
      {cvDocument ? (
        <DocumentCard
          imageUrl={URL.createObjectURL(cvDocument)}
          onDelete={() => handleCVChange(null, "cv")}
        />
      ) : (
        <CVDocumentUploader
          onCVChange={(file) => handleCVChange(file, "cv")}
          loading={loadingCV}
        />
      )}
    </>
  );
};

export default CVForm;
